import { useQuery } from '@tanstack/react-query';

import { getContestSlates } from '../domains/services/contest.service.api';

export const useContestSlates = (contestId: string, enabled = true) => {
  // eslint-disable-next-line local-rules/require-query-stale-time
  const { data, isLoading, error } = useQuery({
    queryKey: ['contest-slates', contestId],
    queryFn: () => getContestSlates({ contestId }),
    enabled: !!contestId && enabled,
  });

  return { data, isLoading, error };
};
